import { extractRenderPropsChildren, RenderPropsChildren } from '../../../libs/renderProps'
import { Component } from 'preact'

import SearchBox from '../../../preact-components/search-box/SearchBox'

interface RenderProps<T> {
  items: T[] | undefined
  value: string
}

interface Props {
  items?: any[]
  placeholder?: string
  children: RenderPropsChildren<RenderProps<any>>
  onClickSelectAll?: () => void
  selectionLabel?: string
}

interface State {
  value: string
}

class SearchableFilterSelector extends Component<Props, State> {
  state = { value: '' }

  render({ items, placeholder, children, onClickSelectAll, selectionLabel }: Props, { value }: State) {
    const filteredItems = items?.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    )
    return (
      <div class='overview__filters-box-content'>
        <SearchBox
          isModerationOverview
          placeholder={placeholder}
          value={value}
          onSubmit={() => {}}
          onInput={(e) => this.setState({ value: (e.target as HTMLInputElement).value })}
          onClear={() => this.setState({ value: '' })}
        />
        {filteredItems && filteredItems.length === 0 && (
          <div class='overview__filters-box-content-no-results'>No results found</div>
        )}
        {filteredItems && filteredItems.length > 0 && (
          <p class='select-all' onClick={onClickSelectAll}>{selectionLabel}</p>
        )}
        {extractRenderPropsChildren(children)({ items: filteredItems, value })}
      </div>
    )
  }
}

export default SearchableFilterSelector
